 import {observable, action, computed} from "mobx"
import axios from "axios"

class DemandeStore{
  @observable user={
    nom: "",
    prenom: "",
    email: "",
    telephone: ""
  }
  @observable bien=""
  @observable typededemandes =[]
  constructor() {
    axios.get("/api/v1/gettypesdedemandes").then((data)=>{
      this.typededemandes = data.data
    })
  }

}

let store = new DemandeStore()
global.DemandeStore = store
export default store
